var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 22.5V28.5C32 29.2956 31.6839 30.0587 31.1213 30.6213C30.5587 31.1839 29.7956 31.5 29 31.5H8C7.20435 31.5 6.44129 31.1839 5.87868 30.6213C5.31607 30.0587 5 29.2956 5 28.5V22.5",
    stroke: "#FD6202",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26 12L18.5 4.5L11 12",
    stroke: "#FD6202",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.5 4.5V22.5",
    stroke: "#FD6202",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.70a822e8635d21ed1e6fe9c37e7ba069.svg";
export { ForwardRef as ReactComponent };